import React from 'react';
import { Message } from 'oskari-ui';
/**
 * @class Oskari.mapframework.bundle.publisher2.PublisherBundleInstance
 *
 * Main component and starting point for the "map publisher" functionality. Publisher
 * is a wizardish tool to configure a subset of map functionality. It uses the map
 * plugin functionality to start and stop plugins when the map is running. Also it
 * changes plugin language and map size.
 *
 * See Oskari.mapframework.bundle.publisher2.PublisherBundle for bundle definition.
 *
 */
Oskari.clazz.define('Oskari.mapframework.bundle.publisher2.PublisherBundleInstance',
/**
 * @method create called automatically on construction
 * @static
 */
function () {
  // override defaults
  var conf = this.getConfiguration();
  conf.name = 'Publisher2';
  conf.flyoutClazz = 'Oskari.mapframework.bundle.publisher2.Flyout';
  this.defaultConf = conf;
  this.publisher = null;
  this.customTileRef = null;
  this.loc = Oskari.getMsg.bind(null, 'Publisher2');
}, {
  /**
   * @static
   * @property __name
   */
  __name: 'Publisher2',
  /**
   * @method getName
   * @return {String} the name for the component
   */
  getName: function getName() {
    return this.__name;
  },
  /**
   * @method onEvent
   * Event is handled forwarded to correct #eventHandlers if found or discarded if not.
   * @param {Oskari.mapframework.event.Event} event a Oskari event object
   */
  onEvent: function onEvent(event) {
    var handler = this.eventHandlers[event.getName()];
    if (!handler) {
      return;
    }
    return handler.apply(this, [event]);
  },
  init: function init() {
    var tileElem = jQuery(this.getConfiguration().tileElement);
    if (tileElem.length && tileElem.length !== 0) {
      this.customTileRef = this.getConfiguration().tileElement;
      this.conf.tileClazz = null;
      this.customElementClickHandler(tileElem);
    }
  },
  /**
   * @property {Object} eventHandlers
   * @static
   */
  eventHandlers: {
    /**
     * @method Publisher.MapPublishedEvent
     * @param {Oskari.mapframework.bundle.publisher.event.MapPublishedEvent} event
     */
    'Publisher.MapPublishedEvent': function PublisherMapPublishedEvent(event) {
      var me = this;
      var iframeCode = event.getUrl() + '" allow="geolocation" style="border: none;';
      var width = event.getWidth();
      var height = event.getHeight();
      if (width !== null && width !== undefined) {
        iframeCode += ' width: ' + width + ';';
      }
      if (height !== null && height !== undefined) {
        iframeCode += ' height: ' + height + ';';
      }
      var textCode = '<iframe src="' + iframeCode + '"></iframe>';
      var codeSnippet = '<div class="codesnippet"><code>&lt;iframe src="' + iframeCode + '"&gt;&lt;/iframe&gt;</code></div>';
      var content = me.loc('published.desc') + '<br/><br/>' + codeSnippet;
      var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
      var closeBtn = dialog.createCloseButton();
      closeBtn.addClass('primary');
      var copyBtn = Oskari.clazz.create('Oskari.userinterface.component.Button');
      copyBtn.setTitle(me.loc('published.copy'));
      copyBtn.setHandler(function () {
        var el = dialog.getElement().find('.codesnippet');
        Oskari.util.copyTextToClipboard(textCode, el);
      });
      var title = me.loc('published.title');
      dialog.show(title, content, [copyBtn, closeBtn]);
      me.setPublishMode(false);
    }
  },
  /**
   * @method afterStart
   */
  afterStart: function afterStart() {
    var me = this;
    var sandbox = this.getSandbox();
    var loc = this.getLocalization();
    this.__service = Oskari.clazz.create('Oskari.mapframework.bundle.publisher2.PublisherService', sandbox);

    // Let's add publishable filter to layerlist if user is logged in
    if (Oskari.user().isLoggedIn()) {
      var mapLayerService = Oskari.getSandbox().getService('Oskari.mapframework.service.MapLayerService');
      mapLayerService.registerLayerFilter('publishable', function (layer) {
        return layer.hasPermission('publish');
      });

      // Add layerlist filter button
      var layerlistService = Oskari.getSandbox().getService('Oskari.mapframework.service.LayerlistService');
      if (layerlistService) {
        layerlistService.registerLayerlistFilterButton(loc.layerFilter.buttons.publishable, loc.layerFilter.tooltips.publishable, {
          active: 'layer-publishable',
          deactive: 'layer-publishable-disabled'
        }, 'publishable');
      }
    }
    var infoDialog;
    var openingOnAppStart = false;
    // check from url parameters if publisher should be opened to edit some specific view.
    var uuid = Oskari.util.getRequestParam('editPublished');
    if (uuid) {
      // Create an info popup. Opening publisher might take a while since we have to wait for the map layers to load.
      infoDialog = me._showOpeningPublisherMsg();
      // Create edit request handler callback
      openingOnAppStart = true;
      // Send request on app start
      Oskari.on('app.start', function () {
        if (Oskari.user().isLoggedIn()) {
          me._sendEditRequest(uuid);
        } else {
          infoDialog.close();
          me._showOpeningPublisherErrorMsg('login');
        }
      });
    }
    // create and register request handler
    var reqHandler = Oskari.clazz.create('Oskari.mapframework.bundle.publisher.request.PublishMapEditorRequestHandler', me._openPublisherForEditingCbFactory(infoDialog, openingOnAppStart));
    sandbox.requestHandler('Publisher.PublishMapEditorRequest', reqHandler);
    this._registerForGuidedTour();
  },
  /**
   * @private @method _openPublisherForEditingCbFactory
   * Factory function to create a callback function for PublishMapEditorRequestHandler.
   * Callback function waits for required layers to load and opens the publisher.
   * @return {Oskari.userinterface.component.Popup} infoDialog for closing when callback finishes (optional)
   * @return {Boolean} openingOnAppStart (optional)
   * @return {function} callback function for PublishMapEditorRequestHandler
   */
  _openPublisherForEditingCbFactory: function _openPublisherForEditingCbFactory(infoDialog, openingOnAppStart) {
    var me = this;
    var layerCheckDone = false;
    return function (data) {
      var _data$configuration;
      if (!openingOnAppStart || layerCheckDone) {
        // open publisher
        me.setPublishMode(true, data);
        return;
      }
      // Opening on startup
      // Check that the data contains selected layers configuration
      var selectedLayers = (data === null || data === void 0 || (_data$configuration = data.configuration) === null || _data$configuration === void 0 || (_data$configuration = _data$configuration.mapfull) === null || _data$configuration === void 0 || (_data$configuration = _data$configuration.state) === null || _data$configuration === void 0 ? void 0 : _data$configuration.selectedLayers) || [];
      // Perform layer check only once when opening the publisher on startup.
      layerCheckDone = true;
      if (!selectedLayers.length) {
        if (infoDialog) {
          infoDialog.fadeout();
        }
        me._showOpeningPublisherErrorMsg();
        return;
      }
      var mapLayerService = me.sandbox.getService('Oskari.mapframework.service.MapLayerService');
      var timeoutInMillis = 1000; // one second;
      var maxTries = 30;
      var numTries = 0;

      // Interval checks if layers have been loaded.
      var intervalId = setInterval(function () {
        var layerIds = selectedLayers.map(function (l) {
          return l.id;
        });
        var layersFound = mapLayerService.hasLayers(layerIds);

        // try until we get the layers...
        if (layersFound) {
          if (infoDialog) {
            infoDialog.close();
          }
          clearInterval(intervalId);
          me.setPublishMode(true, data);
          return;
        }
        numTries++;

        // ...or the max try count is reached
        if (numTries === maxTries) {
          clearInterval(intervalId);
          if (infoDialog) {
            infoDialog.fadeout();
          }
          me._showOpeningPublisherErrorMsg();
        }
      }, timeoutInMillis);
    };
  },
  /**
   * @private @method _sendEditRequest
   * Sends Publisher.PublishMapEditorRequest with given uuid.
   *
   * @param uuid {String} Uuid for the view to edit.
   */
  _sendEditRequest: function _sendEditRequest(uuid) {
    var requestBuilder = Oskari.requestBuilder('Publisher.PublishMapEditorRequest');
    this.sandbox.request(this, requestBuilder({
      uuid: uuid
    }));
  },
  /**
   * @return {Oskari.mapframework.bundle.publisher2.PublisherService} service for state holding
   */
  getService: function getService() {
    return this.__service;
  },
  /**
   * @return {String} reference to element-id to use instead of tile as bundle ui-element, returns null if isn't set in conf
   */
  getCustomTileRef: function getCustomTileRef() {
    return this.customTileRef;
  },
  /**
   * @method customElementClickHandler
   * @param {jQuery} tileElement
   */
  customElementClickHandler: function customElementClickHandler(tileElement) {
    var me = this;
    tileElement.on('click', function () {
      me.getSandbox().postRequestByName('userinterface.UpdateExtensionRequest', [me, 'toggle']);
    });
  },
  /**
   * @method setPublishMode
   * Transform the map view to publisher mode if parameter is true and back to normal if false.
   * Makes note about the map layers that the user cant publish, removes them for publish mode and
   * returns them when exiting the publish mode.
   *
   * @param {Boolean} blnEnabled true to enable, false to disable/return to normal mode
   * @param {Object} data View data that is used to prepopulate publisher (optional)
   * @param {Layer[]} deniedLayers layers that the user can't publish (optional)
   */
  setPublishMode: function setPublishMode(blnEnabled, data, deniedLayers) {
    var me = this;
    var root = jQuery(Oskari.dom.getRootEl());
    var navigation = root.find('nav');
    navigation.css('display', blnEnabled ? 'none' : 'block');
    var mapContainer = Oskari.dom.getMapContainerEl();
    var extraClasses = ['mapPublishMode', Oskari.dom.APP_EMBEDDED_CLASS];
    if (this.getCustomTileRef()) {
      blnEnabled ? jQuery(this.getCustomTileRef()).addClass('activePublish') : jQuery(this.getCustomTileRef()).removeClass('activePublish');
    }
    if (blnEnabled) {
      var _data, _Object$keys, _data2;
      if (me.publisher) return;
      data = data || this.getDefaultData();
      me.getService().setIsActive(true);
      if ((_data = data) !== null && _data !== void 0 && _data.configuration && ((_Object$keys = Object.keys(data.configuration)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) {
        // if there exists some configuration we're calling set state, which is calling UIChangeEvent under the hood.
        var stateRB = Oskari.requestBuilder('StateHandler.SetStateRequest');
        this.getSandbox().request(this, stateRB(data.configuration));
      } else {
        // Otherwise there's no need to update the state and we can just notify everybody of ui change.
        var eventBuilder = Oskari.eventBuilder('UIChangeEvent');
        this.sandbox.notifyAll(eventBuilder(this.mediator.bundleId));
      }
      if ((_data2 = data) !== null && _data2 !== void 0 && _data2.uuid) {
        this._showEditNotification();
      }
      me.getService().setNonPublisherLayers(deniedLayers || this.getNonPublisherLayers());
      me.getService().removeLayers();
      me.oskariLang = Oskari.getLang();
      extraClasses.forEach(function (cssClass) {
        return mapContainer.classList.add(cssClass);
      });

      // hide flyout
      me.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [me, 'hide']);
      me.publisher = Oskari.clazz.create('Oskari.mapframework.bundle.publisher2.view.PublisherSidebar', me, me.getLocalization('BasicView'), data);

      // call set enabled before rendering the panels (avoid duplicate "normal map plugins")
      me.publisher.setEnabled(true);
      me.publisher.render(root);
    } else {
      Oskari.setLang(me.oskariLang);
      if (me.publisher) {
        // reset tile status
        me.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [me, 'close']);
        me.publisher.setEnabled(false);
        me.publisher.destroy();
        me.publisher = null;
      }
      // first return all needed plugins before adding the layers back
      extraClasses.forEach(function (cssClass) {
        return mapContainer.classList.remove(cssClass);
      });
      me.getService().setIsActive(false);
      // return the layers that were removed for publishing.
      me.getService().addLayers();
      me.getFlyout().close();
    }
  },
  /**
   * Initial data for publisher to preselect certain tools by default and assume current map state as starting point
   * @return {Object}
   */
  getDefaultData: function getDefaultData() {
    var config = {
      mapfull: {
        conf: {
          plugins: [{
            id: 'Oskari.mapframework.mapmodule.ControlsPlugin'
          }, {
            id: 'Oskari.mapframework.mapmodule.GetInfoPlugin'
          }]
        }
      },
      featuredata: {
        conf: {}
      },
      featuredata2: {
        conf: {}
      }
    };
    if (!this.getSandbox().getMap().getSupports3D()) {
      config.mapfull.conf.plugins.push({
        id: 'Oskari.mapframework.bundle.mapmodule.plugin.ScaleBarPlugin'
      });
    }
    // setup current mapstate so layers are not removed
    var state = this.getSandbox().getCurrentState();
    // merge state to initial config
    return {
      configuration: jQuery.extend(true, config, state)
    };
  },
  /**
   * @method _showEditNotification
   * Shows notification that the user starts editing an existing published map
   * @private
   */
  _showEditNotification: function _showEditNotification() {
    var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
    dialog.show(this.loc('edit.popup.title'), this.loc('edit.popup.msg'));
    dialog.fadeout();
  },
  /**
   * @private @method _showOpeningPublisherMsg
   * Notify user that we are getting ready to open his map view for editing.
   * @return {Oskari.userinterface.component.Popup} The popup dialog for closing it later on.
   */
  _showOpeningPublisherMsg: function _showOpeningPublisherMsg() {
    var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
    dialog.show(this.loc('edit.popup.title'), this.loc('edit.popup.published.msg'));
    dialog.makeModal();
    return dialog;
  },
  /**
   * @private @method _showOpeningPublisherErrorMsg
   * Notify user that editing url specified view failed.
   * @param {String} errorKey Localization key for the error message (optional)
   */
  _showOpeningPublisherErrorMsg: function _showOpeningPublisherErrorMsg(errorKey) {
    errorKey = 'edit.popup.published.error.' + (errorKey || 'common');
    var dialog = Oskari.clazz.create('Oskari.userinterface.component.Popup');
    dialog.show(this.loc('edit.popup.published.error.title'), this.loc(errorKey));
    setTimeout(function () {
      dialog.fadeout();
    }, 3000);
  },
  /**
   * @method getNonPublisherLayers
   * Checks currently selected layers and returns a subset of the list
   * that has the layers that can't be published. If all selected
   * layers can be published, returns an empty list.
   * @return
   * {Oskari.mapframework.domain.WmsLayer[]/Oskari.mapframework.domain.WfsLayer[]/Oskari.mapframework.domain.VectorLayer[]/Mixed}
   * list of layers that can't be published.
   */
  getNonPublisherLayers: function getNonPublisherLayers() {
    var _this = this;
    var selectedLayers = this.sandbox.getMap().getLayers();
    var service = this.getService();
    var deniedLayers = selectedLayers.filter(function (layer) {
      return !service.hasPublishRight(layer) || !_this.sandbox.getMap().isLayerSupported(layer);
    });
    return deniedLayers;
  },
  /**
   * @static
   * @property __guidedTourDelegateTemplate
   * Delegate object given to guided tour bundle instance. Handles content & actions of guided tour popup.
   * Function "this" context is bound to bundle instance
   */
  __guidedTourDelegateTemplate: {
    priority: 50,
    show: function show() {
      this.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [null, 'attach', 'Publisher2']);
    },
    hide: function hide() {
      this.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [null, 'close', 'Publisher2']);
    },
    getTitle: function getTitle() {
      return this.getLocalization().guidedTour.title;
    },
    getContent: function getContent() {
      return /*#__PURE__*/React.createElement(Message, {
        bundleKey: this.getName(),
        messageKey: "guidedTour.message",
        allowHTML: true
      });
    },
    getLinks: function getLinks() {
      var me = this;
      var loc = this.getLocalization().guidedTour;
      return [{
        title: loc.openLink,
        onClick: function onClick() {
          return me.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [null, 'attach', 'Publisher2']);
        },
        visible: false
      }, {
        title: loc.closeLink,
        onClick: function onClick() {
          return me.sandbox.postRequestByName('userinterface.UpdateExtensionRequest', [null, 'close', 'Publisher2']);
        },
        visible: true
      }];
    }
  },
  /**
   * @method _registerForGuidedTour
   * Registers bundle for guided tour help functionality. Waits for guided tour load if not found
   */
  _registerForGuidedTour: function _registerForGuidedTour() {
    var me = this;
    function sendRegister() {
      var requestBuilder = Oskari.requestBuilder('Guidedtour.AddToGuidedTourRequest');
      if (requestBuilder && me.sandbox.hasHandler('Guidedtour.AddToGuidedTourRequest')) {
        var delegate = {
          bundleName: me.getName()
        };
        for (var prop in me.__guidedTourDelegateTemplate) {
          if (typeof me.__guidedTourDelegateTemplate[prop] === 'function') {
            delegate[prop] = me.__guidedTourDelegateTemplate[prop].bind(me); // bind methods to bundle instance
          } else {
            delegate[prop] = me.__guidedTourDelegateTemplate[prop]; // assign values
          }
        }
        me.sandbox.request(me, requestBuilder(delegate));
      }
    }
    function handler(msg) {
      if (msg.id === 'guidedtour') {
        sendRegister();
      }
    }
    var tourInstance = me.sandbox.findRegisteredModuleInstance('GuidedTour');
    if (tourInstance) {
      sendRegister();
    } else {
      Oskari.on('bundle.start', handler);
    }
  }
}, {
  'extend': ['Oskari.userinterface.extension.DefaultExtension']
});